<template>
  <div class="fwwd">
    <el-card v-for="(item,index) in address" :key="index">
      <p class="lineWord">
        <img src="../../../static/icon/landian.svg" width="12" height="12">
        <span>{{item.Address}}</span><el-button style="float: right;padding:0" @click.native="adres(item)" type="text"><img src="../../../static/icon/weizhi.svg" width="20" height="20"></el-button>
      </p >
      <p class="lineWord">
        <span style="color: #979797">工作地址：</span>{{item.gzdz}}
      </p>
    </el-card>
  </div>
</template>

<srcipt src="https://res.wx.qq.com/open/js/jweixin-1.6.0.js"></srcipt>
<script>

  import {getQueryVariable, weixinInit} from "@/utils";

export default {
  name: "fuwuwangdian",
  data () {
    return {
      address:[
        {
          Address:'邮政储蓄银行庆阳市北街支行',
          gzdz:'西峰区北大街56号（鸿元丽都楼下）',
          wz: [35.743881,107.641255],
        },
        {
          Address:'邮政储蓄银行庆阳市西街支行',
          gzdz:'西峰区长庆大道155号（人民银行向南50米）',
          wz: [35.74434,107.638466]
        },
        {
          Address:'邮政储蓄银行庆阳市东街支行',
          gzdz:'西峰区安定东路1号',
          wz: [35.736732,107.651699],
        },
        {
          Address:'邮政储蓄银行庆阳市南街支行',
          gzdz:'西峰区顺化西路1号（雄越酒店南侧）',
          wz: [35.709888,107.634826],
        },
        {
          Address:'邮政储蓄银行庆阳市和谐广场支行',
          gzdz:'西峰区马莲河大道75号（和谐广场西侧）',
          wz: [35.713052,107.647929],
        },{
          Address:'工商银行北街支行',
          gzdz:'鸿元丽都楼下',
          wz: [35.743881,107.641255],
        },{
          Address:'工商银行中街支行',
          gzdz:'市政府礼堂隔壁',
          wz: [35.734009,107.64302],
        },{
          Address:'工商银行南街支行',
          gzdz:'老毛纺厂对面',
          wz: [35.727837,107.642099],
        },{
          Address:'工商银行西峰新区支行',
          gzdz:'中元世贸斜对面',
          wz: [35.72092,107.643215],
        },{
          Address:'工商银行西峰开发区支行',
          gzdz:'雄越酒店对面',
          wz: [35.714501,107.645145],
        },{
          Address:'工商银行西峰庆化支行',
          gzdz:'世纪新村楼下',
          wz: [35.734803,107.63453],
        },{
          Address:'工商银行西峰东街支行',
          gzdz:'九龙路西峰区政府南侧',
          wz: [35.729407,107.651965],
        },{
          Address:'兰州银行庆阳西峰支行',
          gzdz:'九龙北路101号（九龙商场南门斜对面）',
          wz: [35.743245,107.647098],
        },{
          Address:'兰州银行庆阳新区支行',
          gzdz:'西峰区真宁一路C17号（雄越小区楼下）',
          wz: [35.715767,107.643758],
        },{
          Address:'甘肃银行庆阳分行营业部',
          gzdz:'庆阳市西峰区弘华西路1号甘肃银行大厦',
          wz: [35.712986,107.647945],
        },{
          Address:'甘肃银行庆阳南大街支行',
          gzdz:'庆阳市西峰区南大街东方丽景茂1层东南角',
          wz: [35.725898,107.650424],
        },{
          Address:'甘肃银行西峰区支行',
          gzdz:'庆阳市西峰区九龙南路庆阳三中向北50米锦龙商务大厦一楼',
          wz: [35.739575,107.657261],
        },{
          Address:'甘肃银行庆阳北大街支行',
          gzdz:'庆阳市西峰区北大街258号鸿元丽都一楼（邮政局斜对面）',
          wz: [35.750676,107.647161],
        },{
          Address:'甘肃银行庆阳东郊支行',
          gzdz:'庆阳市西峰区兰州东路金昊义乌小商品城一楼',
          wz: [35.727114,107.664762],
        },{
          Address:'甘肃银行庆阳西郊支行',
          gzdz:'庆阳市西峰区长庆北路锦阳名居小区一楼',
          wz: [35.741846,107.638871],
        },{
          Address:'甘肃银行安定路支行',
          gzdz:'庆阳市西峰区安定东路昊鑫时代广场南侧一楼',
          wz: [35.736456,107.650329],
        },{
          Address:'甘肃银行庆阳小什字支行',
          gzdz:'庆阳市西峰区小什字丽景百货一楼南侧',
          wz: [35.740909,107.648847],
        },
      ]
    }
  },
  created() {
    const companyCode = sessionStorage.getItem('companyCode')?sessionStorage.getItem('companyCode'):getQueryVariable("state")
    weixinInit(companyCode);
    if(!sessionStorage.getItem('theFlag')) {
      sessionStorage.setItem('theFlag',1)
      window.location.reload()
    }
  },
  methods:{
    adres(item){
      wx.ready(()=>{
        wx.openLocation({
          latitude: item.wz[0], // 纬度，浮点数，范围为90 ~ -90
          longitude:item.wz[1], // 经度，浮点数，范围为180 ~ -180。
          name: item.Address, // 位置名
          address: item.gzdz, // 地址详情说明
          scale: 18, // 地图缩放级别,整型值,范围从1~28。默认为最大
        });
      })
    }
  }
}
</script>

<style scoped>
.fwwd{
  padding: 10px;
  height: 90%;
  overflow-y: auto;
  font-size: 14px;
  /*font-weight: bold;*/
}
.lineWord{
  padding: 8px;
  vertical-align: middle;
  border-bottom: 1px solid #f1f1f1;
}
.text_blue{
  color: #0074FF;
}
.el-card{
  margin-top: 10px;
  border-radius: 4%;
}
.el-divider--horizontal{
  margin-top: 18px;
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/xxcx/hezuoyinhang.vue